export const currencyFormatter = (
  value: number,
  decimalPlaces?: number,
): string => {
  let returnItem: string = '';

  if (!decimalPlaces) {
    decimalPlaces = 0;
  }

  if (value !== null && value !== undefined) {
    returnItem = parseFloat(value.toString().replace(/,/g, ''))
      .toFixed(decimalPlaces)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      .replace('NaN', '');
  }
  return returnItem;
};

export const convertStringtoDollarString = (value: any): string => {
  return `$${currencyFormatter(Number(value))}`;
};

export const convertdollarStringtoNumber = (value: string): number => {
  const strippedValue: any = value.replace(/\$|,/g, '');
  if (strippedValue && !isNaN(strippedValue)) {
    return parseFloat(strippedValue);
  } else {
    return 0;
  }
};

export const formatCurrency = (amount: string) => {
  const minus = amount.substring(0, 1);
  const num = amount.substring(1);
  if (minus === '-') {
    return minus + '$' + num;
  } else {
    return '$' + amount;
  }
};
